$(document).ready(function () {
  $(".sessLnk").on("click", function (e) {
    e.preventDefault();
    let sessModal = $("#SessionModal");
    
    sessModal.modal("show");
    
    sessModal.find(".modal-body").load($(this).attr("href"), function(response, status) {
      if (status === "error") {
        let errorMsg = '<p class="text-center">Error loading content. Please try again later.</p>';
        $(this).html(errorMsg);
      }
    });
  });
});